import IconLevel1Colored from '@repo/ui-icons/IconLevel1Colored';
import IconLevel2Colored from '@repo/ui-icons/IconLevel2Colored';
import IconLevel3Colored from '@repo/ui-icons/IconLevel3Colored';
import IconLevel4Colored from '@repo/ui-icons/IconLevel4Colored';

import type { SurveyOption } from '../../SimpleSurvey';

export const surveyOptions: SurveyOption[] = [
  {
    id: 'beginner',
    label: 'Beginner',
    icon: IconLevel1Colored,
  },
  {
    id: 'intermediate',
    label: 'Intermediate',
    icon: IconLevel2Colored,
  },
  {
    id: 'advanced',
    label: 'Advanced',
    icon: IconLevel3Colored,
  },
  {
    id: 'expert',
    label: 'Professional',
    icon: IconLevel4Colored,
  },
];
